import { useContext } from 'react';
import { Scope } from '@/contexts/ScopeContext';

export const useScope = () => {
  const ctx = useContext(Scope);

  if (ctx == null) {
    throw new Error(
      'useScope must be used within a <ScopeProvider>. Ensure your component tree is wrapped by ScopeProvider.'
    );
  }

  return ctx;
};
